import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Localiser} from "../../../services/localiser";
import {ZonaService} from "../../../services/zona.service";
import {plano} from "../../../models/plano";
import {zona} from "../../../models/zona";

@Component({
  selector: 'app-delete-zone',
  templateUrl: './delete-zone.component.html',
  styleUrls: ['./delete-zone.component.css']
})
export class DeleteZoneComponent implements OnInit {

  planos: Array<plano>;
  zona;

  constructor(public dialogRef: MatDialogRef<DeleteZoneComponent>, @Inject(MAT_DIALOG_DATA) public data,
              public localiser: Localiser, public zonaService: ZonaService) { }

  ngOnInit(): void {
    this.planos = this.data.planos;
    this.zona = this.data.zona;
  }

  getPlanoNombre(idPlano) {
    return this.planos.find(plano => plano.idPlano == idPlano).nombre;
  }

  deleteZona() {
    this.zonaService.delete(this.zona.id).subscribe(result => {
      this.dialogRef.close(true);
    }, error => {
      this.dialogRef.close(true);
    })
  }

  getNumberOfRowsForLuminarias(luminarias) {
    return Array(Math.ceil(luminarias.length / 2));
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

}
